import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import declineIcon from '../../../../../../../assetss/img/declineIcon.svg'
import './index.scss'

const DeclineMeetTime = () => (
  <Grid className='newAvtorRequestMessageDeclineWrapper'>
    <Grid className='newAvtorRequestMessageDecline'>
      <img className='checkIcon' src={declineIcon} />
      <Typography className='newTextBox'>
        You have declined meeting date and time. Negotiate another one.
      </Typography>
    </Grid>
  </Grid>
)

export default DeclineMeetTime
